import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Configuration } from "src/app/app.constants";
import { CreateVenueMapRequest, IVenueMapViewModel, UpdateVenueMapRequest } from "../../shared/interfaces/map/venueMapViewModel.interface";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class VenueMapsService {

  constructor(private http: HttpClient, private configuration: Configuration) {
    
  }

  /**
   * Getter that dynamically builds the actionUrl each time.
   * This ensures the URL updates when the backend API changes (e.g., account switching).
   */
  private get actionUrl(): string {
    return this.configuration.buildEndpoint(`VenueMap/`);
  }

  get(id: number): Observable<IVenueMapViewModel> {
    return this.http.get<IVenueMapViewModel>(`${this.actionUrl}${id}`);
  }

  list(): Observable<IVenueMapViewModel[]> {
    return this.http.get<IVenueMapViewModel[]>(this.actionUrl);
  }

  add(model: CreateVenueMapRequest): Observable<IVenueMapViewModel> {
    return this.http.post<IVenueMapViewModel>(this.actionUrl, model);
  }

  update(model: UpdateVenueMapRequest): Observable<IVenueMapViewModel> {
    return this.http.put<IVenueMapViewModel>(`${this.actionUrl}${model.id}`, model);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.actionUrl}${id}`);
  }

  validateName(name: string, id: number = 0): Observable<string> {
    return this.http.put(`${this.actionUrl}${id}/ValidateName`, { name }, { responseType: 'text' });
  }
}
